import { CpsIndex } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class IndexesService {
  public async getIndexes(): Promise<CpsIndex[]> {
    return ExecuteEndpoint(`indexes`, 'GET');
  }
}
